import { Radio } from 'antd';
import styled from 'styled-components';

const BLUE_COLOR = '#2953f3';
const WHITE_COLOR = '#fff';

export const CustomSelectContainer = styled.div`
	display: flex;
	gap: 32px;
	margin-top: 32px;
	margin-bottom: 32px;
	justify-content: space-between;

	@media (max-width: 576px) {
		flex-direction: column;
	}
`;

export const RadioButton = styled(Radio.Button)`
	padding: 10px;
	height: 56px;
	width: 100%;
	font-size: 18px;
	text-align: center;
	border-radius: 9px !important;
	font-weight: 600;
	border: 2px solid #e6e6e6 !important;
	margin: 0;

	&.ant-radio-button-wrapper-checked {
		background: ${BLUE_COLOR} !important;
		color: ${WHITE_COLOR} !important;
		font-weight: 700;
		box-shadow: 0 0 0 2px #e6f0ff;
	}

	&:not(.ant-radio-button-wrapper-checked):hover {
		border-color: ${BLUE_COLOR} !important;
		background: #f5f8ff !important;
	}

	&:not(.ant-radio-button-wrapper-checked) {
		background: ${WHITE_COLOR} !important;
		font-weight: 600;
	}
`;
